<template>
    <div>
        <!-- Filter Section -->
        <b-card title="Filters" class="mb-0">
          <b-form @submit.prevent>
            <b-row>
              <!-- Date Start -->
              <b-col cols="12" md="2">
              <b-form-group
                  :label="$t('apps.reportLedger.singular.dateStart')"
                  label-for="date-start"
                >
                <flat-pickr
                  id="date-start"
                  :config="dateFormat"
                  v-model="form.dateStart"
                  class="form-control form-control-sm"
                />
              </b-form-group>
              </b-col>

              <!-- Date End -->
            <b-col cols="12" md="2">
              <b-form-group
                :label="$t('apps.reportLedger.singular.dateEnd')"
                label-for="date-start"
              >
                <flat-pickr
                  id="date-end"
                  :config="dateFormat"
                  v-model="form.dateEnd"
                  class="form-control form-control-sm"
                />
              </b-form-group>
            </b-col>

              <!-- Office Id -->
              <b-col cols="12" md="2">
                <b-form-group
                  :label="$t('globalSingular.office')"
                  label-for="office"
                >
                  <v-select
                    class="select-size-sm"
                    v-model="form.office"
                    :options="LOV.offices"
                    :reduce="field => field.id"
                    label="name"
                    @option:selected="handleOffice"
                  />
                </b-form-group>
              </b-col>
              <!-- agent or office id -->
              <!-- <b-col cols="12" md="2">
                <b-form-group
                  :label="$t('globalSingular.office')"
                  label-for="office"
                >
                  <v-select
                    class="select-size-sm"
                    v-model="form.officeId"
                    :options="LOV.offices"
                    :reduce="field => field.id"
                    label="label"
                  />
                </b-form-group>
              </b-col> -->
                <!-- Button Filter -->
                <b-col cols="12" md="2">
                    <b-button block variant="primary" size="sm" @click="getReport" class="mt-2 pd-1">
                        {{ $t('globalActions.find') }}
                    </b-button>
                </b-col>
            </b-row>
          </b-form>
        </b-card>
        <!-- bawah filters  -->
        <!-- button print  -->
        <div class="d-flex justify-content-end mt-1 mb-1">
          <b-button variant="outline-primary" @click="print">
            <feather-icon icon="FileIcon" />
            {{ $t('globalActions.print') }}
          </b-button>
          <b-button-group class="ml-1">
            <b-dropdown right variant="outline-primary">
                <template #button-content>
                  <feather-icon icon="DownloadIcon"/>
                  {{ $t('globalActions.export') }}
                </template>
                <b-dropdown-item-button @click="exportToPDF">PDF</b-dropdown-item-button>
                <b-dropdown-item-button @click="exportToExcel">Excel</b-dropdown-item-button>
            </b-dropdown>
          </b-button-group>
        </div>
        <!-- Table Container Card -->
        <b-card no-body id="pdfDom">
            <b-card-body class="text-center">
              <b-card-title>{{ companyName }}</b-card-title>
              <b-card-sub-title>
                <div>{{ $t('apps.reportSummaryCHBACC.singular.report') }}</div>
                <div class="mt-sm-1">{{ periodReportText }}</div>
              </b-card-sub-title>
            </b-card-body>

            <!-- table  -->
            <b-table
                id="refListTable"
                ref="refListTable"
                no-provider-paging
                no-provider-filtering
                :filter-included-fields="columnToBeFilter"
                :fields="tableColumns"
                :items="itemLists"
                :filter="searchQuery"
                responsive
                primary-key="id"
                show-empty
                :busy="isBusy"
                empty-text="No matching records found"
                :sort-desc.sync="isSortDirDesc"
                class="position-relative"
                :tbody-tr-class="rowClass"
            >
            <template #table-busy>
                <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
                  <div class="text mb-1">
                    <b-spinner class="align-middle"/>
                  </div>
                  <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
                </div>
            </template>

            <template #cell(agent)="{ item }">
                <span :class="['d-block', 'text-nowrap', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '']">
                    {{ item.agent }}
                </span>
            </template>

            <template #cell(ch_inv_amount)="{ item }">
                <span :class="['d-block', 'text-nowrap', 'text-right', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '', (parseFloat(item.ch_inv_amount) > 0) ? 'text-success' : (parseFloat(item.ch_inv_amount) < 0) ? 'text-danger' : '']">
                    <div v-if="parseFloat(item.ch_inv_amount) < 0 && parseFloat(item.ch_inv_amount) !== 0">
                        ( {{ formatCurrency(Math.abs(parseFloat(item.ch_inv_amount)), false) }} )
                    </div>
                    <div v-else>
                        {{ formatCurrency(parseFloat(item.ch_inv_amount) || 0, false) }}
                    </div>
                </span>
            </template>

            <template #cell(ch_ericsson_amount)="{ item }">
                <span :class="['d-block', 'text-nowrap', 'text-right', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '', (parseFloat(item.ch_ericsson_amount) > 0) ? 'text-success' : (parseFloat(item.ch_ericsson_amount) < 0) ? 'text-danger' : '']">
                    <div v-if="parseFloat(item.ch_ericsson_amount) < 0 && parseFloat(item.ch_ericsson_amount) !== 0">
                        ( {{ formatCurrency(Math.abs(parseFloat(item.ch_ericsson_amount)), false) }} )
                    </div>
                    <div v-else>
                        {{ formatCurrency(parseFloat(item.ch_ericsson_amount) || 0, false) }}
                    </div>
                </span>
            </template>

            <template #cell(ch_huawei_amount)="{ item }">
                <span :class="['d-block', 'text-nowrap', 'text-right', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '', (parseFloat(item.ch_huawei_amount) > 0) ? 'text-success' : (parseFloat(item.ch_huawei_amount) < 0) ? 'text-danger' : '']">
                    <div v-if="parseFloat(item.ch_huawei_amount) < 0 && parseFloat(item.ch_huawei_amount) !== 0">
                        ( {{ formatCurrency(Math.abs(parseFloat(item.ch_huawei_amount)), false) }} )
                    </div>
                    <div v-else>
                        {{ formatCurrency(parseFloat(item.ch_huawei_amount) || 0, false) }}
                    </div>
                </span>
            </template>

            <template #cell(ch_collection_amount)="{ item }">
                <span :class="['d-block', 'text-nowrap', 'text-right', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '', (parseFloat(item.ch_collection_amount) > 0) ? 'text-success' : (parseFloat(item.ch_collection_amount) < 0) ? 'text-danger' : '']">
                    <div v-if="parseFloat(item.ch_collection_amount) < 0 && parseFloat(item.ch_collection_amount) !== 0">
                        ( {{ formatCurrency(Math.abs(parseFloat(item.ch_collection_amount)), false) }} )
                    </div>
                    <div v-else>
                        {{ formatCurrency(parseFloat(item.ch_collection_amount) || 0, false) }}
                    </div>
                </span>
            </template>

            <template #cell(ch_other_amount)="{ item }">
                <span :class="['d-block', 'text-nowrap', 'text-right', (item.agent === 'TOTAL') ? 'font-weight-bolder text-primary' : '', (parseFloat(item.ch_other_amount) > 0) ? 'text-success' : (parseFloat(item.ch_other_amount) < 0) ? 'text-danger' : '']">
                    <div v-if="parseFloat(item.ch_other_amount) < 0 && parseFloat(item.ch_other_amount) !== 0">
                        ( {{ formatCurrency(Math.abs(parseFloat(item.ch_other_amount)), false) }} )
                    </div>
                    <div v-else>
                        {{ formatCurrency(parseFloat(item.ch_other_amount) || 0, false) }}
                    </div>
                </span>
            </template>
            </b-table>
        </b-card>
    </div>
</template>
<script>
import {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownItemButton,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onMounted, ref } from '@vue/composition-api'
import useListTable from '@/comp-functions/useListTable'
import { formatCurrency, unformatNumber } from '@/utils/formatter'
// import useFormResource from '@/comp-functions/useFormResource'
import { getYears } from '@/utils'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import useHttp from '@/comp-functions/useHttp'
;


export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    flatPickr,
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownItemButton,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BSpinner,
  },
  computed: {
    companyName () {
      return this.$store.state.user.currentCompany.name
    }
  },
  setup () {
    const { $get } = useHttp()
    const selectedOffice = ref({
      id: null,
      name: ''
    })

    const dateFormat = ref({ dateFormat: 'd/m/Y', allowInput: true })

    const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists
    } = useListTable({ url: false })

    const periodReportText = ref()
    const form = ref({
                    dateStart: moment().startOf('month').format('DD/MM/YYYY'),
                    dateEnd: moment().endOf('month').format('DD/MM/YYYY'),
                    office: null
                })

    const LOV = ref({
      year: getYears(),
      offices: [],
    })

    const columnToBeFilter = ['agent']

    // Table Handlers
    const tableColumns = [
      { key: 'agent', label: 'AGENT' },
      { key: 'ch_inv_amount', label: 'CHBACC', thClass: 'text-right', tdClass: 'text-right' },
      { key: 'ch_ericsson_amount', label: 'PRJ. ERICSSON', thClass: 'text-right', tdClass: 'text-right' },
      { key: 'ch_huawei_amount', label: 'PRJ. HUAWEI', thClass: 'text-right', tdClass: 'text-right' },
      { key: 'ch_collection_amount', label: 'COLLECT', thClass: 'text-right', tdClass: 'text-right' },
      { key: 'ch_other_amount', label: 'OTHER', thClass: 'text-right', tdClass: 'text-right' },
    ]

    const getReport = async () => {
        const params = [
            `dateStart=${form.value.dateStart}`,
            `dateEnd=${form.value.dateEnd}`,
            `office=${form.value.office}`
        ]
        const url = `reports/chbacc/summary?${ params.join('&') }`
        await fetchLists(url)

        // Calculate totals and add total row
        if (itemLists.value && itemLists.value.length > 0) {
            let totalChInvAmount = 0
            let totalChEricssonAmount = 0
            let totalChHuaweiAmount = 0
            let totalChCollectionAmount = 0
            let totalChOtherAmount = 0

            // Calculate totals from all items
            itemLists.value.forEach(item => {
                totalChInvAmount += parseFloat(item.ch_inv_amount || 0)
                totalChEricssonAmount += parseFloat(item.ch_ericsson_amount || 0)
                totalChHuaweiAmount += parseFloat(item.ch_huawei_amount || 0)
                totalChCollectionAmount += parseFloat(item.ch_collection_amount || 0)
                totalChOtherAmount += parseFloat(item.ch_other_amount || 0)
            })

            // Create total row object
            const totalRow = {
                agent: 'TOTAL',
                contact_id: 0,
                ch_inv_amount: totalChInvAmount.toString(),
                ch_ericsson_amount: totalChEricssonAmount.toString(),
                ch_huawei_amount: totalChHuaweiAmount.toString(),
                ch_collection_amount: totalChCollectionAmount.toString(),
                ch_other_amount: totalChOtherAmount.toString()
            }

            // Add total row at the end
            itemLists.value.push(totalRow)
        }

        // Set period text for report header
        periodReportText.value = `Period: ${form.value.dateStart} - ${form.value.dateEnd}`
    }

    const handleOffice = (val) => { selectedOffice.value = {id: val.id, name: val.name} }

    const getOffice = async () => {
      const { data } = await $get({ url: `master/offices`})
      LOV.value.offices = data
      form.value.office = LOV.value.offices[0].id
      // console.log(data)
    }

    const rowClass = (item) => {
      if (item && item.agent === 'TOTAL') {
        return 'table-total-row'
      }
      return null
    }

    onMounted(async () => {
      await getOffice()
      getReport()
    })
    return {
        form,
        LOV,
        dateFormat,
        handleOffice,
        periodReportText,
        getReport,
        tableColumns,
        rowClass,
        isBusy,
        itemLists,
        perPage,
        currentPage,
        totalList,
        dataMeta,
        perPageOptions,
        searchQuery,
        isSortDirDesc,
        refListTable,
        statusFilter,
        fetchLists,
        columnToBeFilter,
        formatCurrency
    }
  },
  methods: {
    print () {
      window.print()
    },
    exportToPDF () {
      this.$nextTick(() => this.getPdf())
    },
    exportToExcel () {
      import('@/vendors/Export2Excel').then(excel => {
        const list = this.itemLists

        // add title
        const headerTitle = this.tableColumns.map(column => column.label)
        // only take indexData from columnDef,
        const headerVal = this.tableColumns.map(column => column.key)
        const data = this.formatJson(headerVal, list).map((row) => {
          return row.map((cell) => {
            return unformatNumber(cell);
          })
        });
        excel.export_json_to_excel({
          multiHeader: [
            [this.$store.state.user.currentCompany.name, '', '', '', '', '', '', '', '', ''],
            [`${this.$t('apps.reportPurchaseInvoice.singular.purchaseInvoiceReport')}`, '', '', '', '', '', '', '', '', ''],
            [this.periodReportText, '', '', '', '', '', '', '', '', ''],
            ['', '', '', '', '', '', '', '', '', '']
          ],
          header: headerTitle,
          data,
          merges: [
            { s: { c: 0, r: 0 }, e: { c: 9, r: 0 } },
            { s: { c: 0, r: 1 }, e: { c: 9, r: 1 } },
            { s: { c: 0, r: 2 }, e: { c: 9, r: 2 } },
            { s: { c: 0, r: 3 }, e: { c: 9, r: 3 } }
          ],
          filename: `${this.$t('apps.reportPurchaseInvoice.singular.purchaseInvoiceReport')} ${this.periodReportText}`,
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.select-size-md .vs__dropdown-toggle {
  height: 39px;
}
.dropdown-menu .dropdown-item {
    width: 100%;
  }

  /*#pdfDom td, #pdfDom th {*/
  /*  padding: 0.72rem;*/
  /*}*/

  @media print {
    #app {
      * {
        visibility: hidden;
        margin: 0 !important;
      }

      #pdfDom,
      #pdfDom * {
        visibility: visible;
      }

      #pdfDom {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        margin-top: 100px;
      }
    }
  }

  @page {
    size: auto;
  }

  .table-total-row {
    border-top: 2px solid #007bff !important;
    background-color: #f8f9fa !important;
  }

  .table-total-row td {
    border-top: 2px solid #007bff !important;
  }

</style>

